/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IMandsHomeCategoriesImagesContainerData } from './mands-home-categories-images-container.data';
import { IMandsHomeCategoriesImagesContainerProps } from './mands-home-categories-images-container.props.autogenerated';

/**
 *
 * MandsHomeCategoriesImagesContainer component
 * @extends {React.PureComponent<IMandsHomeCategoriesImagesContainerProps<IMandsHomeCategoriesImagesContainerData>>}
 */
export default class MandsHomeCategoriesImagesContainer extends React.PureComponent<
    IMandsHomeCategoriesImagesContainerProps<IMandsHomeCategoriesImagesContainerData>
> {
    public render(): JSX.Element {
        // const { config } = this.props;
        const { slots, config } = this.props;
        const { containerClass } = config;
        const categoryImage1 = slots && slots.categoryImage1 && slots.categoryImage1.length > 0 ? slots.categoryImage1[0] : {};
        const categoryImage2 = slots && slots.categoryImage2 && slots.categoryImage2.length > 0 ? slots.categoryImage2[0] : {};
        const categoryImage3 = slots && slots.categoryImage3 && slots.categoryImage3.length > 0 ? slots.categoryImage3[0] : {};
        const categoryImage4 = slots && slots.categoryImage4 && slots.categoryImage4.length > 0 ? slots.categoryImage4[0] : {};
        return (
            <div className={`kid-hero ${containerClass ? containerClass : ''}`}>
                <div className='row'>
                    <div className='col-3'>
                        <div>{categoryImage1}</div>
                    </div>

                    <div className='col-3'>
                        <div>{categoryImage2}</div>
                    </div>

                    <div className='col-3'>
                        <div>{categoryImage3}</div>
                    </div>
                    <div className='col-3'>
                        <div>{categoryImage4}</div>
                    </div>
                </div>
            </div>
        );
    }
}
